import React, { useEffect, useState } from 'react';
import { closeModal, showModal } from 'lib/components/Modal';
import toast from 'lib/utils/toast';
import { report } from 'lib/utils/dataReport';
import { ATTA_QB_DIALOG } from 'lib/constants/atta';
import awardPrizeServiceV2 from 'lib/services/awardPrizeServiceV2';
import { ERROR_MSG } from 'lib/constants/error';
import Dialog from '../DialogV2';
import { showTipsDialog } from '../TipsDialog';
import './index.scss';

interface ReceiveQBDialogProps {
  deliverRequest: (params: { qqUin: string }) => Promise<any>;
  receiveCallback?: () => void;
  closeModal: () => void;
}

const ReceiveQBDialog = ({ deliverRequest, receiveCallback }: ReceiveQBDialogProps) => {
  const [qqNumber, setQqNumber] = useState('');
  const [confirmQqNumber, setConfirmQqNumber] = useState('');

  useEffect(() => {
    report(ATTA_QB_DIALOG.SHOW);
  }, []);

  // 验证输入是否为数字，且长度在5-12位之间
  const validateQqInput = (value: string) => {
    // 只允许数字
    const numericValue = value.replace(/\D/g, '');
    // 限制长度在10位以内
    return numericValue.slice(0, 10);
  };

  const handleQqInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const validatedValue = validateQqInput(e.target.value);
    setQqNumber(validatedValue);
  };

  const handleConfirmQqInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const validatedValue = validateQqInput(e.target.value);
    setConfirmQqNumber(validatedValue);
  };

  const validateQQNumber = (value: string) => {
    if (value === '') return false;
    const num = parseInt(value, 10);
    // 字段类型位unit32，米大师范围为10000-4294967295
    return num >= 10000 && num <= 4294967295;
  };

  const handleConfirm = async () => {
    report(ATTA_QB_DIALOG.CONFIRM);
    // QQ号长度验证
    if (!validateQQNumber(qqNumber) || !validateQQNumber(confirmQqNumber)) {
      toast.info('请输入正确格式QQ号领取奖励');
      return;
    }

    if (qqNumber !== confirmQqNumber) {
      toast.info('两次输入的QQ号需要一致');
      return;
    }
    toast.loading();
    const res = await deliverRequest({
      qqUin: qqNumber,
    });
    toast.close();
    if (res.code !== 0) {
      report(ATTA_QB_DIALOG.ACCEPT_FAIL);
      awardPrizeServiceV2.handleReceiveGiftFail(res, () => {
        showTipsDialog({
          title: '领取失败',
          content: ERROR_MSG[res?.code] || '请稍后再试，若有疑问请咨询福利鹅微信公众号客服~',
          buttonText: '我知道啦',
        });
      });
      return;
    }
    receiveCallback?.();
    report(ATTA_QB_DIALOG.ACCEPT_SUCCESS);
    showTipsDialog({
      title: '领取成功',
      content: '到账以QQ钱包消息为准，若有疑问请咨询福利鹅微信公众号客服~',
      buttonText: '我知道啦',
    });
  };

  return (
    <Dialog
      title="输入QQ号领Q币"
      customClass="receive-qb-modal"
      keyboard={{ onEnter: handleConfirm, allowEnterInInput: true }}
    >
      <div className="receive-qb-modal__content">
        <div className="receive-qb-modal__content-tips">请确认领取QQ号为正常账户，否则发放失败不予补发哦~</div>
        <div className="receive-qb-modal__content-inputs">
          <div className="receive-qb-modal__content-inputs__item">
            <input
              className="receive-qb-modal__content-inputs__item__qq"
              placeholder="请输入领取QQ号"
              value={qqNumber}
              onChange={handleQqInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
            />
          </div>
          <div className="receive-qb-modal__content-inputs__item">
            <input
              className="receive-qb-modal__content-inputs__item__qq"
              placeholder="请再次确认领取QQ号"
              value={confirmQqNumber}
              onChange={handleConfirmQqInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
            />
          </div>
        </div>
        <div className="receive-qb-modal__content-bottom-tips">单用户仅能绑定1次领取QQ号</div>
        <div className="receive-qb-modal__content-confirm-button" onClick={handleConfirm}>
          确认领取
        </div>
      </div>
    </Dialog>
  );
};

export const showReceiveQBDialog = (params: Omit<ReceiveQBDialogProps, 'closeModal'>) =>
  showModal(<ReceiveQBDialog {...params} closeModal={closeModal} />);

export default ReceiveQBDialog;
